import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';
import { deleteChild } from '../api/deleteChild';
import { R } from '@/Resources.resx';
import { unassociatedChildrenKeyAtom } from '@/features/shared/features/addOrEditChild/model/unassociatedChildrenAtom';

export const deleteChildMutationAtom = atomWithMutation((get) => ({
    mutationFn: async (childId: string): Promise<void> => {
        return deleteChild(childId)
            .then((result) => {
                const queryClient = get(queryClientAtom);
                const unassociatedChildrenKey = get(
                    unassociatedChildrenKeyAtom,
                );
                queryClient.invalidateQueries({
                    queryKey: unassociatedChildrenKey,
                });
                return result;
            })
            .catch((error) => {
                throw new Error(
                    `${R.ErrorDeleteChild} ${error instanceof Error ? error.message : R.UnknownError}`,
                );
            });
    },
}));
